import React from 'react';
import { Link } from 'react-router-dom';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { TextFormattedNumber } from 'components';
import { convertUTCDateToLocalDate } from 'helpers/date';
import DateFormat from './DateFormat';


const CustomerRewardRow = ({subscription}) => {
  const {
    increment_id,
    description,
    status,
    created_at,
    last_run,
    next_run,
    subtotal,
    id
  } = subscription;

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
      >
        <TableCell>
          <Link className="text-primary underline px-5" to={{pathname: `/subscriptions/edit/${id}/${increment_id}`}}>
            {increment_id}
          </Link>
        </TableCell>
        <TableCell>{description}</TableCell>
        <TableCell className="capitalize">
          {status.replaceAll('_', ' ')}
        </TableCell>
        <TableCell>
          <DateFormat date={convertUTCDateToLocalDate(created_at)} />
        </TableCell>
        <TableCell>
          <DateFormat date={convertUTCDateToLocalDate(last_run)} />
        </TableCell>
        <TableCell>
          <DateFormat date={convertUTCDateToLocalDate(next_run)} />
        </TableCell>
        <TableCell>
          <TextFormattedNumber
            value={subtotal}
            prefix="$"
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default CustomerRewardRow;
